import axios from "axios";

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

// Store reference to logout function for use in interceptor
let authLogout = null;

// Function to set the logout function from AuthContext
export const setAuthLogout = (logoutFn) => {
  authLogout = logoutFn;
};

// Attach token to every request
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("azure_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// ⭐ Automatically refresh token when expired
api.interceptors.response.use(
  (res) => res,
  async (err) => {
    // console.log("API error response:", err.response ? err.response.status : err.message);
    // console.log("Original request config:", err.config);
    const originalRequest = err.config;

    // Only refresh on 401/403 from backend
    if (
      err.response &&
      (err.response.status === 401 || err.response.status === 403) &&
      !originalRequest._retry
    ) {
      originalRequest._retry = true;

      // console.warn("Token expired → refreshing silently via MSAL...");

      try {
        const accounts = window.msalInstance.getAllAccounts();

        if (accounts.length === 0) {
          // console.error("No MSAL account found → cannot refresh");
          // window.location.href = "/login";
          return Promise.reject(err);
        }

        // Request new API token silently with correct scope
        const newTokenResponse = await window.msalInstance.acquireTokenSilent({
          account: accounts[0],
          scopes: [`api://${process.env.REACT_APP_AZURE_CLIENT_ID}/access_as_user`],
        });

        // Save new token
        localStorage.setItem("azure_token", newTokenResponse.accessToken);

        // Retry original API call with new token
        originalRequest.headers["Authorization"] =
          `Bearer ${newTokenResponse.accessToken}`;

        return api(originalRequest);
      } catch (refreshError) {
        // console.error("Silent refresh failed, forcing logout:", refreshError);
        
        // Use AuthContext logout if available, otherwise fallback
        if (authLogout) {
          authLogout();
        } else {
          // Fallback logout
          localStorage.removeItem("azure_token");
          localStorage.removeItem("user");
          
          if (window.msalInstance) {
            window.msalInstance.clearCache();
            window.msalInstance.setActiveAccount(null);
          }
          
          window.location.href = "/login";
        }
      }
    }

    return Promise.reject(err);
  }
);

export default api;
